var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatHogar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cat_hogar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_15",
    "data-name": "Rect\\xE1ngulo 15",
    width: 200,
    height: 200,
    fill: "#e8eff1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-home-10",
    d: "M71.871,1,0,78.255H17.968v64.379H125.775V78.255h17.968Zm0,115.882C62.247,106.414,53.9,98.6,53.9,90.957c0-11.08,14.536-13.944,17.968-3.045C75.309,77,89.839,79.89,89.839,90.957,89.839,98.6,81.5,106.42,71.871,116.882Zm47.914-76.656L101.818,20.912V7.438h17.968Z",
    transform: "translate(28.129 28.083)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatHogar);
export default __webpack_public_path__ + "static/media/cat_hogar.2fde21eb70d91ea0f709c6c9445c6fbd.svg";
export { ForwardRef as ReactComponent };